import React from 'react';
import CountUp from 'react-countup';
import { useLanguage } from '../../context/LanguageContext';

import icon1 from '../../images/funfact/1.svg';
import icon2 from '../../images/funfact/2.svg';
import icon3 from '../../images/funfact/3.svg';
import icon4 from '../../images/funfact/4.svg';
import ImageBg from '../../images/funfact/top-image.jpg';

const FunFact = (props) => {
    const { t } = useLanguage();

    return (
        <section className="funfact-section">
            <div className="top-image">
                <img src={ImageBg} alt="Evcil Hayvan İstatistikleri Görseli" />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <img src={icon1} alt="Kedi ve Köpek Ürünleri İkonu" />
                            </div>
                            <h2><CountUp end={8} enableScrollSpy /><span className="ico">+</span></h2>
                            <h3>{t('funfact.products')}</h3>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <img src={icon2} alt="Mutlu Evcil Hayvan Sahibi İkonu" />
                            </div>
                            <h2><CountUp end={3} enableScrollSpy /> <span className="ico">{t('funfact.customersUnit')}</span></h2>
                            <h3>{t('funfact.customers')}</h3>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <img src={icon3} alt="Veteriner Uzman Takımı İkonu" />
                            </div>
                            <h2><CountUp end={30} enableScrollSpy /> <span className="ico">+</span></h2>
                            <h3>{t('funfact.team')}</h3>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-12">
                        <div className="item">
                            <div className="icon">
                                <img src={icon4} alt="Güvenilir Hayvan Sağlığı İkonu" />
                            </div>
                            <h2><CountUp end={90} enableScrollSpy /> <span className="ico">%</span></h2>
                            <h3>{t('funfact.protection')}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FunFact;
